import { Box, type BoxProps } from "@stenajs-webui/core";
import { cssColor } from "@stenajs-webui/theme";

export const ShadowlessCard = ({ children, ...boxProps }: BoxProps) => (
  <Box
    borderRadius={24}
    border={`1px solid ${cssColor("--silver-ui")}`}
    {...boxProps}
  >
    {children}
  </Box>
);
